import * as React from "react";
import { Link } from "react-router-dom";

import { Card, Label } from "../semantic-ui";
import { Timestamp } from "../common";
import { GameState, coordinatesEqual, Board } from "../board";
import { gameUrl } from "../urls";
import { withSession, SessionProps } from "../session";
import PlayerInfo from "./PlayerInfo";
import { GameFragment } from "../graphql/game";

type Props = SessionProps & {
  game: GameFragment;
};

const GameCard = ({ game, me }: Props) => {
  const gameState = GameState.fromGame(game);
  const flipped = !!(me && me.id === game.black.id);
  const viewerColor =
    me && me.id === game.white.id
      ? "white"
      : me && me.id === game.black.id
      ? "black"
      : undefined;
  return (
    <Card>
      <Card.Content>
        <Card.Header>
          <PlayerInfo
            game={game}
            gameState={gameState}
            showColorNames={false}
          />
        </Card.Header>
        <Card.Meta>
          <Timestamp value={game.updatedAt} />
        </Card.Meta>
      </Card.Content>
      <Card.Content style={{ padding: 0, overflow: "hidden" }}>
        <Link to={gameUrl(game.id)}>
          {game.winner ? null : game.toAct === viewerColor ? (
            <Label
              color="red"
              style={{ position: "absolute", margin: "5px 0 0 15px" }}
            >
              Your move!
            </Label>
          ) : null}
          <Board
            style={{ pointerEvents: "none" }}
            flipped={flipped}
            stones={gameState.stones}
            pieces={gameState.pieces}
            squareClassName={(c) =>
              gameState.lastMoveCoords &&
              coordinatesEqual(gameState.lastMoveCoords[0], c)
                ? Board.squareClasses.highlightLight
                : gameState.lastMoveCoords &&
                  coordinatesEqual(gameState.lastMoveCoords[1], c)
                ? Board.squareClasses.highlightDark
                : null
            }
          />
        </Link>
      </Card.Content>
    </Card>
  );
};

export default withSession(GameCard);
